<template>
	<top-offices :filters="computeFilters" :take="take" :vertical="vertical"></top-offices>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";
	import topOffices from "@/components/webComponents/widget/topOffices/topOffices.vue";

	export default {
		components: {
			topOffices
		},
		props: {
			json: {
				type: String,
				default: undefined
			},
			pageFilters: {
				type: String,
				default: "{}"
			},
			take: {
				type: Number,
				default: 3
			},
			vertical: {
				type: Boolean,
				default: false
			}
		},
		setup(props, context) {
			const $json = inject("$json");

			const globalFilters = ref({});
			const filter = ref([]);

			if ($json.packed(props.json)) {
				filter.value = JSON.parse($json.unpack(props.json));
			} else {
				filter.value = JSON.parse(props.json || "[]");
			}

			if ($json.packed(props.pageFilters)) {
				globalFilters.value = JSON.parse($json.unpack(props.pageFilters));
			} else {
				globalFilters.value = JSON.parse(props.pageFilters || "{}");
			}

			const computeFilters = computed(() => {
				if (filter.value.length > 0) {
					return filter.value;
				} else if (globalFilters.value.UsersFilter.length > 0) {
					return globalFilters.value.UsersFilter;
				} else {
					return globalFilters.value.Parent?.UsersFilter || [];
				}
			});

			return {
				computeFilters
			};
		}
	};
</script>
